export default __webpack_public_path__ + "static/media/bonyad-nokhbe.655cf074.png";